// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tk-0";